export const MERCHANT_REWARD_HISTORY_STATUS = {
    REDEEMED: 'redeemed',
    USED: 'used',
    VIEWED: 'viewed',
} as const;

export const MERCHANT_REWARD_HISTORY_STATUS_LABELS = {
    [MERCHANT_REWARD_HISTORY_STATUS.REDEEMED]: 'Redeemed',
    [MERCHANT_REWARD_HISTORY_STATUS.USED]: 'Used',
    [MERCHANT_REWARD_HISTORY_STATUS.VIEWED]: 'Viewed',
} as const;

export const MERCHANT_REWARD_HISTORY_NOTIFICATION_MESSAGES = {
    RESEND_SUCCESS: 'Reward resent successfully',
    RESEND_ERROR: 'Failed to resend reward',
    FETCH_ERROR: 'Failed to load reward history',
    STATISTIC_ERROR: 'Failed to load statistics',
} as const;

export const MERCHANT_REWARD_HISTORY_FILTER_OPTIONS = [
    { value: 'all', label: 'All Status' },
    { value: MERCHANT_REWARD_HISTORY_STATUS.USED, label: 'Used' },
    { value: MERCHANT_REWARD_HISTORY_STATUS.REDEEMED, label: 'Redeemed' },
    { value: MERCHANT_REWARD_HISTORY_STATUS.VIEWED, label: 'Viewed' },
];

export const MERCHANT_REWARD_HISTORY_PAGINATION_SIZE = 20;

